import { toast } from 'sonner';
import { NarrationAudioSettingsBar } from '@/components/NarrationAudioSettingsBar';
import {
  NARRATION_TTS_PROVIDER_LABELS,
  narrationSelectedVoiceLabel,
} from '@/lib/narrationAudioSettings';

/**
 * Labeled audio provider + voice block for generate-audio dialogs.
 */
export function NarrationAudioSettingsPanel({
  settings,
  onChange,
  onChooseVoice,
  disabled = false,
  className = '',
  testId = 'narration-audio-settings-panel',
}) {
  const handleChooseVoice = () => {
    if ((settings?.tts_provider || 'auto') === 'auto') {
      toast.info('Choose ElevenLabs, Murf, or MiniMax as the audio provider first');
      return;
    }
    onChooseVoice?.();
  };

  const providerLabel = NARRATION_TTS_PROVIDER_LABELS[settings?.tts_provider] || settings?.tts_provider || 'Auto';
  const voiceLabel = narrationSelectedVoiceLabel(settings);

  return (
    <div
      className={`rounded-xl border p-3 space-y-2 ${className}`}
      style={{ borderColor: 'var(--glass-border)', background: 'var(--bg-tertiary)' }}
      data-testid={testId}
    >
      <div>
        <p className="text-xs font-semibold" style={{ color: 'var(--text-primary)' }}>
          Audio provider &amp; voice
        </p>
        <p className="text-[11px] mt-0.5" style={{ color: 'var(--text-tertiary)' }}>
          Pick TTS engine and voice before generating. Settings apply to this run.
        </p>
      </div>
      <NarrationAudioSettingsBar
        settings={settings}
        onChange={onChange}
        onChooseVoice={handleChooseVoice}
        disabled={disabled}
        layout="block"
      />
      <p className="text-[11px]" style={{ color: 'var(--text-secondary)' }} data-testid={`${testId}-summary`}>
        <span className="font-medium" style={{ color: 'var(--text-primary)' }}>{providerLabel}</span>
        {' · '}
        {voiceLabel}
      </p>
    </div>
  );
}
